import GroupIcon from "@mui/icons-material/Group";
import React, {FunctionComponent} from "react";
import {makeStyles} from "tss-react/mui";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import {useHistory, useLocation} from "react-router-dom";
import {ListItemButton, Menu, MenuItem, Theme} from "@mui/material";
import {useAppDispatch} from "@/Redux/Redux";
import _ from "lodash";
import {DRAWER_WIDTH} from "@/Components/Sidebar/Constants";
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import {useTranslation} from "@/Utils/CustomHooks/useTranslation";

interface MenuGeneralDataProps {
    viewData?: any;
}

const useStyles = makeStyles()((theme: Theme) => ({
    listItem: {
        color: "#fff",
    },
    listItemIcon: {
        color: "#fff !important",
    },
    active: {
        backgroundColor: "#e42022!important",
        borderColor: "#e42022!important",
        fontWeight: 600,
    }
}));

const MenuGeneralData: FunctionComponent<MenuGeneralDataProps> = ({ viewData }): JSX.Element => {
    const {classes, cx} = useStyles();
    const dispatch = useAppDispatch();
    const history = useHistory();

    const location = useLocation();
    const {t} = useTranslation();

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    const rights = viewData?.viewer?.rights;

    const isActive = (pathname: string, exact: boolean = false) => {
        if (exact) {
            return location.pathname === pathname;
        }
        return _.includes(location.pathname, pathname);
        //return pathname === location.pathname;
    };
    return (
        <>
            <ListItemButton
                dense
                key={"customers"}
                data-testid={"sidebarMenuGeneral"}
                className={cx(
                    classes.listItem,
                    isActive("/manager/customers", true) ||
                    isActive("/manager/customer/") || isActive("/manager/suppliers", true) ||
                    isActive("/manager/suppliers/") || isActive("/manager/transfer-drivers", true) ||
                    isActive("/manager/transfer-drivers/") ||
                    isActive("/manager/drivers/") ||
                    isActive("/manager/vehicles", true) ||
                    isActive("/manager/vehicle/")
                        ? classes.active
                        : ""
                )}
                onClick={handleClick}
            >
                <ListItemIcon className={classes.listItemIcon}>
                    <GroupIcon/>
                </ListItemIcon>
                <ListItemText primary={t('sidebar.general-data')}/>
                <ChevronRightIcon/>
            </ListItemButton>
            <Menu
                id="basic-menu"
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}
                sx={{
                    '& .MuiPaper-root': {
                        width: DRAWER_WIDTH
                    }
                }}
            >
                <MenuItem
                    data-testid={"sidebarGeneralCustomer"}
                    onClick={() => {
                        history.push("/manager/customers");
                        handleClose()
                    }}>{t("sidebar.customers")}</MenuItem>
                {rights?.find(
                    (right: any) => right.right === "VERM_LIEF_BEARB",
                ) && <MenuItem
                    data-testid={"sidebarGeneralSuppliers"}
                    onClick={() => {
                        history.push("/manager/suppliers");
                        handleClose()
                    }}>{t("sidebar.suppliers")}</MenuItem>}
                <MenuItem
                    data-testid={"sidebarGeneralDriver"}
                    onClick={() => {
                        history.push("/manager/drivers");
                        handleClose()
                    }}>{t("sidebar.drivers")}</MenuItem>
                <MenuItem
                    data-testid={"sidebarGeneralTransferDriver"}
                    onClick={() => {
                        history.push("/manager/transfer-drivers");
                        handleClose()
                    }}>{t("sidebar.transfer-drivers")}</MenuItem>
                <MenuItem
                    data-testid={"sidebarGeneralVehicle"}
                    disabled={
                        rights?.findIndex(
                            (e) => e.right === "VERKAUF",
                        ) === -1
                    }
                    onClick={() => {
                        history.push("/manager/vehicles");
                        handleClose()
                    }}>{t("sidebar.vehiclesearch")}</MenuItem>
            </Menu>
        </>
    );
};

export default MenuGeneralData;
